<!-- 开票明细 -->
<template>
  <div class="app-container">
    <!-- 用户信息 -->
    <el-descriptions title="用户信息">
      <el-descriptions-item label="用户姓名">{{ userInfo.userName }}</el-descriptions-item>
      <el-descriptions-item label="手机号">
        {{ userInfo.phone }}
        <span v-if="userInfo.phone">
          <img v-if="!dataVisible.phone" src="@/assets/eye-close.png" @click="toggleVisibility('phone')" />
          <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('phone')" />
        </span>
      </el-descriptions-item>
      <el-descriptions-item label="身份证号">
        {{ userInfo.idCard }}
        <span v-if="userInfo.idCard">
          <img v-if="!dataVisible.idCard" src="@/assets/eye-close.png" @click="toggleVisibility('idCard')" />
          <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('idCard')" />
        </span>
      </el-descriptions-item>
    </el-descriptions>

    <!-- 开票信息 -->
    <div class="detail-section">
      <div class="section-header">
        <span class="title">开票信息</span>
        <el-button size="small" type="primary" @click="handleExport">导出</el-button>
      </div>
      <el-table :data="tableData" v-loading="tableLoading" border style="width: 100%">
        <el-table-column label="操作" prop="action" width="140" fixed="left">
          <template slot-scope="scope">
            <el-link type="primary" @click="handleEdit(scope.row)">修改</el-link>
            <el-link style="margin-left: 12px;" type="primary" @click="handleDelete(scope.row)">删除</el-link>
          </template>
        </el-table-column>
        <el-table-column label="签约公司" prop="signCompanyName" min-width="150"></el-table-column>
        <el-table-column label="开票金额" prop="invoiceMoney" min-width="120"></el-table-column>
        <el-table-column label="发票时间" prop="applyDate" min-width="120"></el-table-column>
      </el-table>
      <div style="text-align: right; margin-top: 12px; font-size: 14px; color: #606266;">
        开票金额合计: {{ tableData.reduce((total, row) => total + (Number(row.invoiceMoney) || 0), 0) }}元
      </div>
    </div>
    <!-- 修改弹窗 -->
    <InvoiceApplyDialog :dialog-visible.sync="editDialogVisible" :row-data="currentRowData" :is-edit="true" :invoice-id="invoiceId" @success="handleEditSuccess" />
  </div>
</template>

<script>
import { getInvoiceInfoDetail, removeInvoiceInfo } from '@/api/invoiceManagement'
import InvoiceApplyDialog from './components/InvoiceApplyDialog.vue'

export default {
  name: 'InvoiceInfoDetail',
  components: {
    InvoiceApplyDialog
  },
  data() {
    return {
      tableLoading: false,
      invoiceId: '',
      userInfo: {
        userName: '',
        phone: '',
        idCard: ''
      },
      tableData: [],
      // 修改弹窗相关
      editDialogVisible: false,
      currentRowData: {},
      // 脱敏数据相关
      originUserInfo: {},
      dataVisible: {
        phone: false,
        idCard: false
      },
      phone: '',
      idCard: ''
    }
  },
  created() {
    this.invoiceId = this.$route.query.invoiceId
    if (this.invoiceId) {
      this.getDetail()
    }
  },
  methods: {
    // 获取详情数据
    async getDetail() {
      this.tableLoading = true
      try {
        const res = await getInvoiceInfoDetail(this.invoiceId)
        if (res.statusCode === 200 && res.data) {
          this.userInfo = {
            userName: res.data.userName || '',
            phone: res.data.phone || '',
            idCard: res.data.idCard || ''
          }
          this.originUserInfo = { ...this.userInfo }
          this.tableData = (res.data.detailList || []).map(item => ({
            ...item,
            userName: res.data.userName || ''
          }))

          // 处理脱敏数据
          if (res.data.desensitizationDtoList && Array.isArray(res.data.desensitizationDtoList)) {
            const phoneMappings = {
              phone_phone: 'phone',
              idCard_idCard: 'idCard'
            }
            res.data.desensitizationDtoList.forEach(item => {
              const targetProperty = phoneMappings[item.sensitizationCode]
              if (targetProperty) {
                this[targetProperty] = {
                  sensitizationCode: item.sensitizationCode,
                  message: item.message
                }
              }
            })
          }
        } else {
          this.$message.error(res.message || '获取详情失败')
        }
      } catch (error) {
        console.error('获取详情失败', error)
        this.$message.error('获取详情失败')
      } finally {
        this.tableLoading = false
      }
    },
    // 修改
    handleEdit(row) {
      this.currentRowData = { ...row }
      this.editDialogVisible = true
    },
    // 修改成功回调
    handleEditSuccess() {
      this.getDetail()
    },
    // 删除
    async handleDelete(row) {
      try {
        await this.$confirm('确认删除该条开票记录？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        const res = await removeInvoiceInfo(row.id)
        if (res.statusCode === 200) {
          this.$message.success('删除成功')
          this.getDetail()
        } else {
          this.$message.error(res.message || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除失败', error)
          this.$message.error('删除失败')
        }
      }
    },
    // 导出
    handleExport() {
      const url = `/autoapp-default-server-recovery/api/invoice/info/exportDetail`
      const title = '开票明细导出'
      const params = { invoiceId: this.invoiceId }
      this.HttpService.post(url, params).then(res => {
        if (res.statusCode == 200) {
          this.$message.success('正在导出, 稍后请到下载中心查看')
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    // 获取明文数据
    getSourceOrigin(data) {
      return this.HttpService.post(`/autoapp-default-server-recovery/api/deSensitization/getSource`, data).then(res => {
        if (res.statusCode === 200) {
          return res.data
        }
      })
    },
    // 切换数据显示状态
    toggleVisibility(dataType) {
      // 切换显示状态
      this.dataVisible[dataType] = !this.dataVisible[dataType]

      // 根据不同类型处理显示逻辑
      switch (dataType) {
        case 'phone':
          if (this.dataVisible.phone && this.phone.message) {
            this.getSourceOrigin(this.phone).then(res => {
              this.$set(this.userInfo, 'phone', res)
            })
          } else if (!this.dataVisible.phone) {
            // 还原为原始脱敏数据
            this.$set(this.userInfo, 'phone', this.originUserInfo.phone)
          }
          break
        case 'idCard':
          if (this.dataVisible.idCard && this.idCard.message) {
            this.getSourceOrigin(this.idCard).then(res => {
              this.$set(this.userInfo, 'idCard', res)
            })
          } else if (!this.dataVisible.idCard) {
            // 还原为原始脱敏数据
            this.$set(this.userInfo, 'idCard', this.originUserInfo.idCard)
          }
          break
      }
    }
  }
}
</script>

<style scoped lang="scss">
.detail-section {
  margin-top: 20px;

  .section-header {
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      font-size: 16px;
      font-weight: bold;
      color: #303133;
    }
  }
}

// 脱敏数据眼睛图标样式
::v-deep .el-descriptions-item__content {
  img {
    width: 16px;
    height: 16px;
    cursor: pointer;
    vertical-align: middle;
    margin-left: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/invoiceManagement/limitMonitoring/detail.vue